<template>
    <v-flex xs12 sm12 d-block class="card-dados linha card-dados__mobile">
        <h3 class="card-dados__titulo">Notificar Fornecedores por Linha de Fornecimento</h3>

        <az-call-to-action flat css-class="d-flex align-center btn-adicionar" v-if="exibirBotaoAdicionar"
                           @click="exibirCampoDeNovaLinha">
            <v-icon class="icone" color="white">
                add
            </v-icon>
            Nova Linha de Fornecimento
        </az-call-to-action>

        <div class="area-novo" v-show="!exibirBotaoAdicionar">
            <label>Nova Linha de Fornecimento:</label>

            <v-autocomplete v-model="valor" class="area-novo__input" :items="linhasNaoInseridas"
                            autofocus :search-input.sync="buscarLinhasAutocomplete"
                            return-object
                            placeholder="Informe a linha de fornecimento" item-text="codigoDescricao"
                            item-value="codigo" name="Descrição" v-validate="'required'" required
                            :error-messages="errors.collect('Descrição')"
                            ref="linhaAutocomplete">
            </v-autocomplete>

            <v-tooltip top>
                <v-btn id="botaoAdicionar" slot="activator" outline flat small color="primary"
                       @click="adicionarLinha()">
                    <v-icon size="20">check</v-icon>
                </v-btn>
                Adicionar
            </v-tooltip>

            <v-tooltip top>
                <v-btn id="botaoCancelar" slot="activator" outline flat small color="#777"
                       @click="cancelarLinha">
                    <v-icon size="20">close</v-icon>
                </v-btn>
                Cancelar
            </v-tooltip>
        </div>

        <v-data-table :headers="colunas" :items="value"
                      no-data-text="Não há linhas de fornecimento adicionadas"
                      class="az-table-list tabela-linha">
            <template slot="items" slot-scope="props">
                <td>
                    {{props.item.linhaFornecimentoCodigo}} - {{props.item.linhaFornecimentoDescricao}}
                </td>
                <td class="table-actions" >
                    <botao-excluir v-show="exibirBotaoExclusao(props.item.origem)" @excluir="exibirDialogoExclusaoLinha(props.item.id)"/>
                </td>
            </template>
        </v-data-table>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoExclusao"
                              @confirmado="tratarEventoExcluirLinha"
                              @recusado="mostrarDialogoExclusao = false"/>
    </v-flex>
</template>

<script>
import {actionTypes} from '@/core/constants'

export default {
    name: 'PainelLinhaFornecimentoEdicao',
    props: {
        value: {
            required: true
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            colunas: [
                {
                    text: 'Linha de Fornecimento',
                    value: 'linhaFornecimentoCodigo',
                    sortable: true,
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '30px',
                    class: 'primary--text'
                }
            ],
            linhaId: null,
            valor: {},
            buscarLinhasAutocomplete: null,
            mostrarDialogoExclusao: false,
            exibirBotaoAdicionar: true,
            linhasNaoInseridas: []
        }
    },
    methods: {
        async adicionarLinha() {
            await this.validarCampoObrigatorio()
            this.habilitarLoadingGlobal()
            const linhaFornecimento = {
                linhaFornecimentoCodigo: this.valor.codigo,
                linhaFornecimentoDescricao: this.valor.descricao
            }
            this.$emit('adicionarLinhaFornecimento', linhaFornecimento)
            this.cancelarLinha()
        },
        cancelarLinha() {
            this.exibirBotaoAdicionar = true
            this.$set(this.valor, 'linhaFornecNova', {})
            this.$validator.reset()
        },
        exibirCampoDeNovaLinha() {
            this.exibirBotaoAdicionar = false
            setTimeout(() => {
                this.focusInput()
            },300)
        },
        exibirDialogoExclusaoLinha(id) {
            this.linhaId = id
            this.mostrarDialogoExclusao = true
        },
        exibirBotaoExclusao(origem) {
            return origem === 'INTERNA'
        },
        tratarEventoExcluirLinha() {
            this.mostrarDialogoExclusao = false
            this.$emit('excluirLinhaFornecimento', this.linhaId)
        },
        async validarCampoObrigatorio() {
            const estaValido = await this.$validator.validate('Descrição')
            if (!estaValido) {
                throw new Error('Campo obrigatório.')
            }
        },
        verificarLinhaAdicionada(linhaCodigo) {
            return this.value.some(item => item.linhaFornecimentoCodigo === linhaCodigo)
        },
        focusInput() {
            this.$refs.linhaAutocomplete.focus()
        }
    },
    watch: {
        async buscarLinhasAutocomplete(linha) {
            if (linha && linha.length > 1) {
                try {
                    this.desabilitarLoadingGlobal()
                    await this.$store.dispatch(actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO, linha)
                    const linhasNaoInseridas = []
                    this.$store.state.linhasFornecimento.forEach(linhaFornec => {
                        if (!this.verificarLinhaAdicionada(linhaFornec.codigo)) {
                            linhasNaoInseridas.push(linhaFornec)
                        }
                    })
                    this.linhasNaoInseridas = linhasNaoInseridas
                    this.focusInput()
                } catch (e) {
                    this.mostrarNotificacaoErro(e.message)
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .linha div[role="listitem"]
        display none

    .tabela-linha
        padding 10px 16px 16px

    .btn-adicionar
        border 0
        color #777 !important
        padding 0
        margin 0 0 0 16px

        &:hover:before, &:focus:before, &:active:before
            background-color #fff

        .icone
            background-color var(--v-primary-base)
            padding 6px
            border-radius 20px
            margin-right 8px

    @media (max-width 720px)
        .linha .btn-adicionar
            margin-bottom 10px

        .tabela-linha
            padding 0

            td:nth-of-type(1):before
                content "Linha de Fornecimento:"

            td:nth-of-type(2):before
                display none
</style>